import React from 'react';

import { DoctorsList } from '../components';

import siteBanner_img from '../assets/img/temp/siteBanner_img_4.jpg';

class Doctors extends React.Component {
  render() {
    return (
      <div>
        <div className="siteBanner siteBanner_docs">
          <img src={siteBanner_img} className="siteBanner_bg"/>
          <h2 className="line">Lékaři</h2>
        </div>
        <DoctorsList
          langs={{
            doctors: this.props.texts.langs.doctors
          }}
        />
      </div>
    );
  }
}

export default Doctors;


// WEBPACK FOOTER //
// ./src/containers/Doctors.js